export enum JOIST_DIRECTION {
    OTHER = 'other',
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
}
